import { SessionContext } from "@/context/SessionContext";
import { Song } from "javascript/library-objects";
import { useContext } from "react";

// New Releases - most recent uploadDate appear first
export function sortByNewReleases(songs: Song[]): Song[] {
	return [...songs].sort((a, b) => b.uploadDate.getTime() - a.uploadDate.getTime());
}
/*
// Most Downloaded - highest numberOfPurchases appear first
export function sortByMostDownloaded(songs: Song[]): Song[] {
  return [...songs].sort((a, b) => (b.numberOfPurchases ?? 0) - (a.numberOfPurchases ?? 0));
}

// Trending - highest clickThroughRate appear first
export function sortByTrending(songs: Song[]): Song[] {
  return [...songs].sort((a, b) => (b.clickThroughRate ?? 0) - (a.clickThroughRate ?? 0));
}

// Personalized for You - songs with most tags matching user intersts appear first
type UserPreferences = {
  genres?: string[];
  artists?: string[];
  instruments?: string[];
  skillLevels?: string[];
};
*/

// Piano
export function filterByPiano(songs: Song[]): Song[] {
	return songs.filter(song =>
		song.instruments && song.instruments.some(inst => inst.name.toLowerCase() === "piano")
	);
}
// Classical
export function filterByClassical(songs: Song[]): Song[] {
	return songs.filter(song =>
		song.genres && song.genres.some(genre => genre.genreName.toLowerCase() === "classical")
	);
}

export function useRecommendedSongs(allSongs: Song[]): Song[] {
	const session = useContext(SessionContext);
	const interests = session?.userInterests;

	if (!interests) return [];

	return allSongs
		.map(song => {
			let score = 0;
			if (interests.genres && song.genres.some(g => interests.genres!.some(ug => ug.genreName === g.genreName))) score++;
			if (interests.artists && song.artists.some(a => interests.artists!.some(ua => ua.artistName === a.artistName))) score++;
			if (interests.instruments && song.instruments.some(i => interests.instruments!.some(ui => ui.name === i.name))) score++;
			return { song, score };
		})
		.filter(({ score }) => score > 0)
		.sort((a, b) => b.score - a.score)
		.map(({ song }) => song);
}
